import React, { useState, useEffect } from 'react';
import { useFetchAllBlogs } from '@/services/blogService';

export const useBlog = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [blogsDataFromBackend, setBlogsDataFromBackend] = useState([]);

  const { data, error } = useFetchAllBlogs();

  useEffect(() => {
    if (data) {
      setBlogsDataFromBackend(data);
      setIsLoading(false);
    } else if (error) {
      console.error('Error fetching spaces data:', error);
      setIsLoading(false);
    }
  }, [data, error]);

  return {
    isLoading,
    setIsLoading,
    blogsDataFromBackend,
  };
};
